/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaEventHandler.on('arango-crm.inquiry-form', function (e) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://unpkg.com/tilt.js@1.2.1/dest/tilt.jquery.min.js';
        document.head.appendChild(script);
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
